const USER = {
  BASE: 'User',
  MAIN: undefined,

  FEEDBACK: {
    BASE: undefined,
    PAGE: undefined,
    // DETAIL: undefined,
  },
  PARTNER: {
    BASE: undefined,
    PAGE: undefined,
    DETAIL: undefined,
  },
  MAIL: {
    BASE: undefined,
    PAGE: undefined,
    DETAIL: undefined,
  },
  INFO: {
    BASE: undefined,
    PAGE: undefined,
    // DETAIL: undefined,
  },
  PROMO: {
    BASE: undefined,
    PAGE: undefined,
    // DETAIL: undefined,
  },
}

USER.MAIN = `${USER.BASE}|Main`

USER.FEEDBACK.BASE = `${USER.BASE}|Feedbacks`
USER.FEEDBACK.PAGE = `${USER.FEEDBACK.BASE}|Page`
// USER.FEEDBACK.DETAIL = `${USER.FEEDBACK.BASE}|Detail`

USER.PARTNER.BASE = `${USER.BASE}|Partners`
USER.PARTNER.PAGE = `${USER.PARTNER.BASE}|Page`
USER.PARTNER.DETAIL = `${USER.PARTNER.BASE}|Detail`

USER.MAIL.BASE = `${USER.BASE}|Mails`
USER.MAIL.PAGE = `${USER.MAIL.BASE}|Page`
USER.MAIL.DETAIL = `${USER.MAIL.BASE}|Detail`

USER.INFO.BASE = `${USER.BASE}|Infos`
USER.INFO.PAGE = `${USER.INFO.BASE}|Page`
// USER.INFO.DETAIL = `${USER.INFO.BASE}|Detail`

USER.PROMO.BASE = `${USER.BASE}|Promocodes`
USER.PROMO.PAGE = `${USER.PROMO.BASE}|Page`
// USER.PROMO.DETAIL = `${USER.PROMO.BASE}|Detail`

export default {
  ...USER
}
